/*
 * SKU Search Enhancement for Empire Theme
 * Intercepts predictive search fetch calls and adds variants.sku
 * to the searchable fields so customers can search by SKU.
 */
(function() {
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.indexOf('/search/suggest') !== -1) {
      // Add resource type and fields including variants.sku
      if (url.indexOf('resources[type]') === -1) {
        url += '&resources[type]=product,query,collection,page,article';
      }
      if (url.indexOf('resources[options][fields]') === -1) {
        url += '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag';
      }
    }
    return originalFetch.apply(this, arguments.length === 1 ? [url] : [url, options]);
  };
})();
